const dashboard = {
  // Page title
  title: 'لوحة التحكم',
  welcomeBack: 'مرحباً بعودتك',

  // Navigation tabs
  tabs: {
    overview: 'نظرة عامة',
    properties: 'العقارات',
    analytics: 'التحليلات',
    team: 'الفريق',
    settings: 'الإعدادات',
  },

  // Overview section
  overview: {
    title: 'نظرة عامة',
    totalViews: 'إجمالي المشاهدات',
    totalClicks: 'إجمالي النقرات',
    totalContacts: 'إجمالي التواصل',
    totalSaves: 'إجمالي الحفظ',
    conversionRate: 'معدل التحويل',
    activeListings: 'الإعلانات النشطة',
    pendingListings: 'الإعلانات المعلقة',
    expiredListings: 'الإعلانات المنتهية',
    recentActivity: 'النشاط الأخير',
    quickActions: 'إجراءات سريعة',
  },

  // Stats
  stats: {
    views: 'المشاهدات',
    clicks: 'النقرات',
    contacts: 'التواصل',
    saves: 'الحفظ',
    listings: 'الإعلانات',
    leads: 'العملاء المحتملين',
    revenue: 'الإيرادات',
    trend: {
      up: 'زيادة',
      down: 'انخفاض',
      fromLastPeriod: 'من الفترة السابقة',
    },
  },

  // Date range
  dateRange: {
    label: 'الفترة الزمنية',
    last7Days: 'آخر 7 أيام',
    last30Days: 'آخر 30 يوم',
    last90Days: 'آخر 90 يوم',
    lastYear: 'آخر سنة',
    allTime: 'كل الوقت',
    custom: 'نطاق مخصص',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    apply: 'تطبيق',
  },

  // Analytics section
  analytics: {
    title: 'التحليلات',
    performanceOverTime: 'الأداء عبر الزمن',
    topProperties: 'أفضل العقارات أداءً',
    viewsChart: 'مخطط المشاهدات',
    clicksChart: 'مخطط النقرات',
    contactsChart: 'مخطط التواصل',
    heatmap: 'خريطة الحرارة',
    heatmapDescription: 'أفضل أوقات المشاهدة',
    marketComparison: 'مقارنة بالسوق',
    yourPerformance: 'أداؤك',
    marketAverage: 'متوسط السوق',
    percentile: 'المئين',
    aboveAverage: 'أعلى من المتوسط',
    belowAverage: 'أقل من المتوسط',
    // كان يُستدعى بلا مفتاح فيظهر اسم المفتاح نفسه (DashboardAnalytics).
    metricsDistribution: 'توزيع المؤشرات',
  },

  // أزرار عامة داخل لوحة التحكم (ExportModal يستدعي common.cancel).
  common: {
    cancel: 'إلغاء',
  },

  // Properties section
  properties: {
    title: 'العقارات',
    allProperties: 'جميع العقارات',
    activeProperties: 'العقارات النشطة',
    pendingProperties: 'العقارات المعلقة',
    expiredProperties: 'العقارات المنتهية',
    addProperty: 'إضافة عقار',
    editProperty: 'تعديل العقار',
    viewProperty: 'عرض العقار',
    deleteProperty: 'حذف العقار',
    renewProperty: 'تجديد الإعلان',
    boostProperty: 'ترقية الإعلان',
    noProperties: 'لا توجد عقارات',
    noPropertiesDescription: 'ابدأ بإضافة عقارك الأول',
  },

  // Team section
  team: {
    title: 'إدارة الفريق',
    subtitle: '{{count}} عضو في الفريق',
    members: 'أعضاء الفريق',
    inviteMember: 'دعوة عضو',
    inviteDescription: 'إرسال دعوة للانضمام إلى فريقك',
    pendingInvites: 'الدعوات المعلقة',
    you: 'أنت',
    joined: 'تاريخ الانضمام',
    role: 'الدور',
    roles: {
      owner: 'مالك',
      admin: 'مدير',
      agent: 'وكيل',
      editor: 'محرر',
      viewer: 'مشاهد',
    },
    roleDescriptions: {
      owner: 'صلاحيات كاملة لجميع الميزات',
      admin: 'إدارة الفريق والعقارات',
      agent: 'إدارة العقارات وعرض التحليلات',
      viewer: 'صلاحية العرض فقط',
    },
    rolesLegend: 'صلاحيات الأدوار',
    status: {
      active: 'نشط',
      pending: 'معلق',
      suspended: 'موقوف',
    },
    filters: {
      all: 'جميع الأعضاء',
      active: 'نشط',
      pending: 'معلق',
    },
    permissions: {
      listings: 'العقارات',
      analytics: 'التحليلات',
      team: 'الفريق',
      subscription: 'الاشتراك',
    },
    fields: {
      email: 'البريد الإلكتروني',
      name: 'الاسم الكامل',
      role: 'الدور',
      permissions: 'الصلاحيات',
    },
    placeholders: {
      email: 'أدخل البريد الإلكتروني',
      name: 'أدخل الاسم الكامل',
    },
    errors: {
      emailRequired: 'البريد الإلكتروني مطلوب',
      invalidEmail: 'يرجى إدخال بريد إلكتروني صحيح',
      emailExists: 'هذا البريد موجود بالفعل في الفريق',
      nameRequired: 'الاسم مطلوب',
      inviteFailed: 'فشل إرسال الدعوة',
    },
    lastActive: 'آخر نشاط',
    remove: 'إزالة',
    cancelInvite: 'إلغاء الدعوة',
    resendInvite: 'إعادة إرسال الدعوة',
    sendInvite: 'إرسال الدعوة',
    sending: 'جاري الإرسال...',
    inviteResent: 'تم إعادة إرسال الدعوة إلى {{email}}',
    confirmRemove: 'هل أنت متأكد من إزالة {{name}} من الفريق؟',
    searchPlaceholder: 'البحث عن أعضاء...',
    noMembers: 'لا يوجد أعضاء في الفريق',
    noMembersDescription: 'قم بدعوة أعضاء فريقك للتعاون',
    noResults: 'لم يتم العثور على أعضاء',
    noResultsDescription: 'جرب تعديل البحث',
    inviteFirst: 'دعوة أول عضو',
  },

  // Export
  export: {
    title: 'تصدير التقارير',
    subtitle: 'تحميل بيانات التحليلات',
    selectFormat: 'اختر الصيغة',
    pdf: 'PDF',
    excel: 'Excel',
    csv: 'CSV',
    pdfDescription: 'تقرير منسق مع رسوم بيانية',
    excelDescription: 'جدول بيانات شامل',
    csvDescription: 'بيانات خام للاستيراد',
    selectDateRange: 'اختر الفترة الزمنية',
    dateRange: 'الفترة الزمنية',
    last30Days: 'آخر 30 يوم',
    selectMetrics: 'اختر المقاييس',
    allMetrics: 'جميع المقاييس',
    includes: 'المحتويات',
    includesSummary: 'ملخص الأداء',
    includesTimeSeries: 'تفاصيل البيانات اليومية',
    includesProperties: 'مقاييس العقارات',
    download: 'تحميل',
    exporting: 'جاري التصدير...',
    success: 'تم تحميل التقرير بنجاح',
    error: 'فشل تحميل التقرير',
  },

  // Contact info
  contactInfo: {
    title: 'معلومات التواصل',
    businessName: 'اسم النشاط',
    phone: 'رقم الهاتف',
    email: 'البريد الإلكتروني',
    whatsapp: 'واتساب',
    workingHours: 'ساعات العمل',
    autoReply: 'الرد التلقائي',
    autoReplyMessage: 'رسالة الرد التلقائي',
    save: 'حفظ التغييرات',
    saved: 'تم حفظ التغييرات',
  },

  // Subscription info
  subscription: {
    title: 'الاشتراك',
    currentPlan: 'الباقة الحالية',
    listingsUsed: 'الإعلانات المستخدمة',
    renewalDate: 'تاريخ التجديد',
    daysRemaining: 'أيام متبقية',
    upgrade: 'ترقية الباقة',
    manage: 'إدارة الاشتراك',
    expired: 'منتهي',
    expiresIn: 'ينتهي خلال',
  },

  // Empty states
  emptyStates: {
    noData: 'لا توجد بيانات',
    noDataDescription: 'لا توجد بيانات متاحة لهذه الفترة',
    noActivity: 'لا يوجد نشاط',
    noActivityDescription: 'لم يتم تسجيل أي نشاط بعد',
  },

  // Loading
  loading: 'جاري التحميل...',
  refreshing: 'جاري التحديث...',
  lastUpdated: 'آخر تحديث',

  // Company Dashboard specific translations
  company: {
    title: 'لوحة تحكم الشركة',
    subtitle: 'نظرة عامة على شركتك',
    propertyUsage: 'استخدام العقارات',

    kpiCards: {
      active: 'نشط',
      pending: 'قيد الانتظار',
      team: 'الفريق',
    },

    quickActions: {
      title: 'إجراءات سريعة',
      properties: 'العقارات',
      team: 'الفريق',
      settings: 'الإعدادات',
    },

    agentBreakdown: {
      title: 'العقارات حسب الوكيل',
      listings: 'عقار',
    },

    recentActivity: {
      title: 'النشاط الأخير',
      created: 'تم الإنشاء',
      updated: 'تم التحديث',
    },

    loading: 'جاري تحميل لوحة التحكم...',
    error: 'فشل تحميل لوحة التحكم',

    empty: {
      noAgents: 'لا يوجد وكلاء بعد',
      noActivity: 'لا يوجد نشاط حديث',
    },
  },
};

export default dashboard;
